<template>
	<div class="home">
		<el-row class="home-top" :gutter="20">
			<el-col :span="10">
				<user-card></user-card>
				<!-- 接入设备总量 -->
				<el-row class="" :gutter="20">
					<!-- <el-col :span="7">
            <gas-amount class="space-21"></gas-amount>
          </el-col>-->
					<el-col :span="24">
						<device-statis class="space-21" @open-meter-rate-dialog="handleOpen"></device-statis>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="7">
				<!-- 抄表率 -->
				<meter-rate ref="meterRate"></meter-rate>
				<!-- 近7日每日通讯上报数对比 -->
				<last-compare class="space-21"></last-compare>
			</el-col>
			<el-col :span="7">
				<!-- 重点告警汇总 -->
				<high-alarm></high-alarm>
			</el-col>
		</el-row>
		<el-row class="home-bottom space-21" :gutter="20">
			<el-col :span="10">
				<!-- 昨日用户用气量Top5 -->
				<use-gas-top5></use-gas-top5>
			</el-col>
			<el-col :span="7">
				<!-- 月用气总量趋势 -->
				<use-gas-trend></use-gas-trend>
			</el-col>
			<el-col :span="7">
				<!-- 月设备发展量趋势 -->
				<device-develop-trend></device-develop-trend>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import UserCard from './components/User.vue'
// import GasAmount from "./components/GasAmount.vue";
import DeviceStatis from './components/DeviceStatis.vue'
import MeterRate from './components/MeterRate.vue'
import LastCompare from './components/LastCompare.vue'
import HighAlarm from './components/HighAlarm.vue'
import UseGasTop5 from './components/UseGasTop5.vue'
import UseGasTrend from './components/UseGasTrend.vue'
import DeviceDevelopTrend from './components/DeviceDevelopTrend.vue'
export default {
	name: 'Home',
	components: {
		UserCard,
		// GasAmount,
		DeviceStatis,
		MeterRate,
		LastCompare,
		HighAlarm,
		UseGasTop5,
		UseGasTrend,
		DeviceDevelopTrend,
	},
	methods: {
		handleOpen() {
			this.$refs.meterRate.handleOpenDialog()
		},
	},
}
</script>
<style scoped lang="scss">
::v-deep .card {
	padding: 24px;
	background: #f2f4fc;
	border-radius: 16px;
	position: relative;
	&-title {
		font-size: 20px;
		font-weight: 500;
		color: #333;
		letter-spacing: 1px;
	}
	.box-number {
		position: absolute;
		left: 24px;
		bottom: 24px;
		.text {
			font-size: 12px;
			color: #999;
		}
		.data {
			margin-top: 10px;
			.unit {
				font-size: 16px;
				font-weight: normal;
				color: #333;
				line-height: 24px;
			}
		}
	}
	.bold {
		font-size: 20px;
		font-family: Impact;
		color: #4d4d4d;
		line-height: 24px;
		letter-spacing: 1px;
	}
}
.home {
	height: 100%;
	padding: 20px 24px;
	display: flex;
	flex-direction: column;
	overflow-y: scroll;

	&-top {
		flex: 0 0 515px;
	}

	&-bottom {
		flex: 1;
		min-height: 300px;
		.el-col {
			height: 100%;
			overflow: hidden;
		}
	}
}
.space-21 {
	margin-top: 21px;
}

@media screen and (max-width: 1860px) {
	::v-deep .card {
		padding: 16px;
		&-title {
			font-size: 17px;
			font-weight: 600;
			color: #333;
			letter-spacing: 1px;
		}
	}
}
</style>
